@if (!isModal) {
  <split-pane-main-header>
    <ion-buttons slot="end">
      @if (!isUnauthenticatedAccess) {
        <new-dataset-button></new-dataset-button>
      }
    </ion-buttons>
  </split-pane-main-header>
  <split-pane-main-content [rootPath]="rootPath" secondaryContentType="routerOutlet">
    <div class="split-pane-main-col1-content">
      <ng-container *ngTemplateOutlet="ListPageTemplate"></ng-container>
    </div>
  </split-pane-main-content>
} @else {
  <ng-container *ngTemplateOutlet="ListPageTemplate"></ng-container>
}

<ng-template #ListPageTemplate>
  <ion-header mode="ios" class="ion-no-border">
    @if (isModal) {
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button fill="clear" color="dark" mode="ios" (click)="dismiss()">
            {{ 'BUTTON.CANCEL' | translate }}
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          @if (enableAllSelection && isMultiSelect) {
            <ion-button fill="clear" color="primary" mode="ios" (click)="toggleSelectAllInFilter()">
              @if (allSelectedInFilter) {
                {{ 'BUTTON.CLEAR_SELECTION' | translate }}
              } @else {
                {{ 'BUTTON.SELECT_ALL' | translate }}
              }
            </ion-button>
          }
          <ion-button strong fill="clear" color="primary" mode="ios" (click)="submit()">
            {{ 'BUTTON.SAVE' | translate }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    } @else if (isPublicWebApp) {
      <ion-toolbar class="search-info-toolbar">
        <div class="search-info-toolbar-text">
          <h5 class="search-info-toolbar-title" [title]="searchInfoTitleKey | translate">
            <span>{{ searchInfoTitleKey | translate }}</span>
            <ion-button class="search-info-toolbar-help-button" fill="clear" size="small" strong
              routerLink="/main/faq"
              [queryParams]="formType === 'selfHelpAddress' ? { id: organizationSubType } : {}">
              <ion-icon name="help-circle-outline"></ion-icon>
              {{ 'BUTTON.HELP' | translate }}
            </ion-button>
          </h5>
          <p class="search-info-toolbar-description" [title]="searchInfoDescriptionKey | translate">
            {{ searchInfoDescriptionKey | translate }}
          </p>
        </div>
      </ion-toolbar>
    }
    <search-toolbar
      [multiFieldSearchPlaceholderKey]="multiFieldSearchPlaceholderKey"
      [currentMultiFieldSearchValue]="currentSearchValue"
      [currentSecondarySearchValue]="currentSecondarySearchValue"
      [filterIsActive]="filterIsActive"
      [showFilter]="showFilterButton"
      [searchOnInputChange]="true"
      [isLoading]="viewStates[currentContentId].isLoading"
      [showSkeleton]="viewStates[currentContentId].showSkeleton"
      [showLocationSearch]="showLocationSearch"
      (multiFieldSearchInput)="onSearchValueUpdated($event)"
      (secondarySearchInput)="onSecondarySearchValueUpdated($event)"
      (filterClicked)="onFilterButtonClicked()">
      <div class="toolbar-meta-wrapper">
        <div class="toolbar-meta">
          <span>{{ totalItemsInDatabase }} {{ 'TERM.SEARCH_RESULT' | translate }}</span>
          @if (!isPublicWebApp) {
            <ion-button class="search-info-button" color="primary" fill="clear" size="small" (click)="openSearchInfoPopover($event)">
              <ion-icon name="information-circle" slot="icon-only"></ion-icon>
            </ion-button>
            <ion-popover class="search-info-popover" mode="md"
              [event]="searchInfoPopoverEvent"
              [isOpen]="isSearchInfoPopoverOpen"
              (didDismiss)="isSearchInfoPopoverOpen = false"
              show-backdrop="false">
              <ng-template>
                <ion-content>
                  <div class="search-info-content">{{'VIEW.ORGANIZATION_LIST.SEARCH.MULTI_FIELD_TOOLTIP' | translate }}</div>
                </ion-content>
              </ng-template>
            </ion-popover>
          }
          @if (showOnlineOffersToggle) {
            <div class="toolbar-meta-toggle-wrapper">
              <ion-toggle mode="md" class="toolbar-meta-toggle" labelPlacement="end"
                [checked]="includeOnlineOffers"
                (ionChange)="onOnlineOffersUpdated($event)">
                {{ 'VIEW.HOME.SEARCH.ONLINE_OFFERS' | translate }}
              </ion-toggle>
            </div>
          }
        </div>
        @if (activeFilterChips.length) {
          <active-filter-chips class="toolbar-wrapper__inner toolbar-wrapper__inner--line-wrap"
            [chips]="activeFilterChips"
            (removeChip)="removeActiveFilterChip($event.id, $event.rawValue)">
          </active-filter-chips>
        }
      </div>
    </search-toolbar>
  </ion-header>
<ion-content class="nakos-list-content" #ListContent
  [ngClass]="{
    'modal-content': isModal,
    'show-skeleton': viewStates[currentContentId].showSkeleton,
    'is-loading': viewStates[currentContentId].isLoading }">
  <ion-refresher slot="fixed"
    [disabled]="viewStates[currentContentId].showSkeleton"
    (ionRefresh)="refresh(currentContentId, $event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div class="proto-content">
    <ion-radio-group [ngModel]="selectedItemIds[0]">
      <ion-list lines="none">
        @for (item of items[currentContentId]; let i = $index; track item ? item.id : i) {
          <organization-preview
            [ngClass]="{ 'is-selected': item?.id === activatedRouteId }"
            [item]="item"
            [isDisabled]="disabledItemIds.includes(item?.id)"
            (openDetail)="onItemClicked($event)">
            @if (isModal) {
              @if (!isMultiSelect) {
                <ion-radio class="list-item-checkbox" [value]="item?.id"></ion-radio>
              } @else {
                <ion-checkbox class="list-item-checkbox" [checked]="selectedItemIds.includes(item?.id)"></ion-checkbox>
              }

            }
          </organization-preview>
        }
      </ion-list>
    </ion-radio-group>


    @if (viewStates[currentContentId].isEmpty || viewStates[currentContentId].hasError) {
      <unavailable-block
        [ngClass]="{ 'is-small': viewStates[currentContentId].isEmpty && isPublicWebApp }"
        [translateKey]="viewStates[currentContentId].isEmpty && isPublicWebApp
          ? 'VIEW.ORGANIZATION_LIST.PUBLIC_UNAVAILABLE'
          : ''"
        [viewStates]="viewStates[currentContentId]"
        (refresh)="refresh(currentContentId)">
      </unavailable-block>

      @if (viewStates[currentContentId].isEmpty && isPublicWebApp && nakosItem) {
        <ion-list lines="none">
          <organization-preview class="nakos-item"
            [ngClass]="{ 'is-selected': nakosItem?.id === activatedRouteId }"
            [item]="nakosItem"
            (openDetail)="onEmptyStateItemClicked($event)">
          </organization-preview>
        </ion-list>
      }
    }
  </div>

  <ion-infinite-scroll
    [disabled]="!viewStates[currentContentId].hasMore"
    (ionInfinite)="loadMore(currentContentId, $event)">
    <ion-infinite-scroll-content>
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
</ng-template>
